import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "top-subtext" }
const _hoisted_4 = { class: "link" }
const _hoisted_5 = { class: "column" }
const _hoisted_6 = { class: "top" }
const _hoisted_7 = { class: "top-subtext" }
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = ["href"]
const _hoisted_10 = { class: "column" }
const _hoisted_11 = { class: "top-with-status" }
const _hoisted_12 = { class: "left" }
const _hoisted_13 = { class: "top-subtext" }
const _hoisted_14 = { class: "right" }
const _hoisted_15 = { class: "status" }
const _hoisted_16 = { class: "bottom" }
const _hoisted_17 = ["href"]

import { computed } from "vue";
import { useStore } from "vuex";
import BaseWidgetTemplate from "@/components/BaseWidgetTemplate.vue";
import type { Appeal } from "@/modules/appeal/types";
import UserIcon from "@/components/icons/UserIcon.vue";
import PhoneIcon from "@/components/icons/PhoneIcon.vue";
import LetterIcon from "@/components/icons/LetterIcon.vue";
import UITooltip from "@/modules/UI-kit/UITooltip.vue";
import { ModalTypes } from "@/enums/enums";

interface Props {
  appeal: Appeal;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppealsListItem',
  props: {
    appeal: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const validateFields = computed(() => {
  const fullName = `${props.appeal.name} ${props.appeal.surname}`;

  const formattedName =
    fullName.length > 18 ? fullName.slice(0, 17) + "..." : fullName;

  const formattedCity =
    props.appeal.city.length > 18
      ? props.appeal.city.slice(0, 17) + "..."
      : props.appeal.city;

  return {
    formattedName,
    fullName,
    formattedCity,
  };
});

const isOverflowedName = computed(() => {
  return !validateFields.value.formattedName.includes("...");
});
const isOverflowedCity = computed(() => {
  return !validateFields.value.formattedCity.includes("...");
});

const openAppeal = () => {
  store.commit("appealsStore/setCurrentAppeal", props.appeal.structure);
  store.commit("modalsStore/showModal", { modalType: ModalTypes.appealModal });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseWidgetTemplate, {
    theme: "gray",
    class: "item"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[0] || (_cache[0] = _createElementVNode("span", { class: "top-text" }, "Заявка", -1)),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.appeal.id), 1)
        ]),
        _createElementVNode("div", {
          class: "bottom user-button",
          onClick: openAppeal
        }, [
          _createVNode(UserIcon, { class: "icon" }),
          _createVNode(UITooltip, {
            disabled: isOverflowedName.value,
            text: validateFields.value.fullName
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_4, _toDisplayString(validateFields.value.formattedName), 1)
            ]),
            _: 1
          }, 8, ["disabled", "text"])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "top-text" }, "Бюджет", -1)),
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.appeal.investAmount), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(PhoneIcon, { class: "icon" }),
          _createElementVNode("a", {
            class: "link",
            target: "_blank",
            href: `tel:${_ctx.appeal.phoneNumber}`
          }, _toDisplayString(_ctx.appeal.phoneNumber), 9, _hoisted_9)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "top-text" }, "Город", -1)),
            _createVNode(UITooltip, {
              disabled: isOverflowedCity.value,
              text: validateFields.value.formattedCity
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_13, _toDisplayString(validateFields.value.formattedCity), 1)
              ]),
              _: 1
            }, 8, ["disabled", "text"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.appeal.status), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(LetterIcon, { class: "icon" }),
          _createElementVNode("a", {
            class: "link",
            target: "_blank",
            href: `mailto:${_ctx.appeal.email}`
          }, _toDisplayString(_ctx.appeal.email), 9, _hoisted_17)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})